module.exports = __webpack_public_path__ + "img/orkocraft.0fc84021.webp";